import { cn, MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Tooltip } from '@makyoapp/makyo-ui'

interface ToggleModeProps {
  isDevelopmentMode: boolean
  setIsDevelopmentMode: (isDevelopmentMode: boolean) => void
  isFullScreen: boolean
}

export const ToggleMode = ({ isDevelopmentMode, setIsDevelopmentMode, isFullScreen }: ToggleModeProps) => {
  return (
    <div className={cn('flex items-center justify-center space-x-4 mt-3 w-full', isFullScreen && 'hidden')}>
      <div
        className='flex items-center bg-zinc-200 dark:bg-slate-200 rounded-lg p-1 cursor-pointer'
        onClick={() => setIsDevelopmentMode(!isDevelopmentMode)}
      >
        <Tooltip content='Design Mode: Click components to edit their settings'>
          <div
            className={`flex items-center px-3 py-1.5 rounded-md transition-all duration-200 ${
              isDevelopmentMode ? 'bg-primary-500 text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <MaterialIcon icon='code' className='mr-1' size={16} />
            <span className='text-m-m font-medium'>Design</span>
          </div>
        </Tooltip>
        <Tooltip content='Preview Mode: Click components to execute their assigned actions'>
          <div
            className={`flex items-center px-3 py-1.5 rounded-md transition-all duration-200 ${
              !isDevelopmentMode ? 'bg-primary-500 text-white shadow-sm' : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <MaterialIcon icon='play_arrow' className='mr-1' size={18} />
            <span className='text-m-m font-medium'>Preview</span>
          </div>
        </Tooltip>
      </div>
    </div>
  )
}
